module.exports = __webpack_public_path__ + "static/media/hiw1blue.95d4c20c.svg";